import { Route } from 'react-router-dom';

import { AdminRoute } from '@/domains/auth';
import { DEMO } from '@/runtime-config';
import { DEMO_PATHS } from './paths';
import { InitialReviewPage } from './screens/initial-review';
import { RankingsPage } from './screens/rankings';
import { TemplatesPage } from './screens/setup';

/**
 * The mock screens' routes, one builder per place they are mounted — each returns nothing at all
 * with the demo off, so no mock address exists in production and each falls to its zone's
 * catch-all, as any unknown address does.
 *
 * **Each mock sits under the guard its zone would give it.** The owner ruled that the mock screens
 * need a real session: the portal's under the portal's zone (an Advisor Portal account), the Team
 * Portal's under the Team Portal's, each under its rail entry's permission — the work and records
 * mocks `responses.browse`, as the live work areas are, and Setup's Templates the bare
 * `AdminRoute`'s default, `roles.manage`. Nothing is mounted beside the front door: its one mock,
 * team registration, went live with SR-213's teams block, and step 3 now points at
 * `/registration` itself.
 */

/** Inside the Team Portal's zone, in its `TeamMain`. */
export function demoTeamRoutes() {
  if (!DEMO) return null;
  return (
    <>
      <Route element={<AdminRoute permission="responses.browse" />}>
        <Route path={DEMO_PATHS.initialReview} element={<InitialReviewPage />} />
        <Route path={DEMO_PATHS.rankings} element={<RankingsPage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path={DEMO_PATHS.templates} element={<TemplatesPage />} />
      </Route>
    </>
  );
}
